//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BaseCmsBlock from '../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin';
import SpecialistCard from '~/pages/specialists/components/SpecialistCard.vue';
import AppointmentModal from '~/components/appointment/AppointmentModal.vue';
import Swiper from 'swiper';

export default BaseCmsBlock.extend({
  name: 'StaffCarouselBlock',

  data() {
    return {
      userId: '',
      swiperOptions: {
        // slidesPerView: 5,
        spaceBetween: 24,
        centerSlides: true,
        loop: true,
        breakpoints: {
          320: {
            slidesPerView: 2,
            spaceBetween: 20
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 20
          },
          1000: {
            slidesPerView: 5,
            spaceBetween: 16,
          },
        },
        navigation: {
          prevEl: '.swiper-button-prev',
          nextEl: '.swiper-button-next'
        }
      },

      repeatInitSlider: null
    };
  },

  computed: {
    title: function () {
      return this?.values?.title || "Наши специалисты"
    }
  },

  mounted() {
    this.initSlider();
  },

  methods: {

    initSlider: function() {

      clearTimeout(this.repeatInitSlider);

      if (document.getElementsByClassName('swiper-staff-carousel').length <= 0) {

        this.repeatInitSlider = setTimeout(() => {
          this.initSlider();
        }, 100);

        return null;
      }

      this.swiper = new Swiper('.swiper-staff-carousel', {
        ...this.swiperOptions
      });
    },

    openModal(id) {
      this.userId = String(id);
    },
    closeModal() {
      this.userId = '';
    }
  },

  components: {
    SpecialistCard,
    AppointmentModal
  }
});
